import { render, staticRenderFns } from "./User.Menu.vue?vue&type=template&id=71047d1b&scoped=true&"
import script from "./User.Menu.vue?vue&type=script&lang=js&"
export * from "./User.Menu.vue?vue&type=script&lang=js&"
import style0 from "./User.Menu.vue?vue&type=style&index=0&id=71047d1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71047d1b",
  null
  
)

export default component.exports